export default __webpack_public_path__ + "static/media/no-job.6e6d2c89.png";